<div dx-resizable="{ handles: 'all', minWidth: 100, maxWidth: 500 }">

  <dx-scroll-view data-testid="vendor-request-scroll-view">
    <form #formElement (submit)="onSubmit($event)">
      <dx-form #dxForm data-testid="form" id="form" class="cards-wide" [formData]="requestData" [items]="formItems" [showValidationSummary]="true" [colCount]="formColCount" validationGroup="formGroup" (onContentReady)="onFormContentReady($event)">

        <dxi-item [colSpan]="formColCount" labelMode="static" dataField="requestType" editorType="dxSelectBox" cssClass="dx-widget" [editorOptions]="{ items: requestTypes, valueExpr: 'name', displayExpr: 'name',
                        required: 'true' , searchMode: 'contains', searchEnabled: true, onSelectionChanged: onRequestTypeSelectionChanged, onOpened: onRequestTypeDropdownOpened, disabled: isEditable }">
          <dxo-label text="Request Type"> </dxo-label>
          <dxi-validation-rule type="required" message="Request Type is required">
          </dxi-validation-rule>
        </dxi-item>
        <div *dxTemplate="let formItemData of 'loanAmountsGridTemplate'">
        </div>
        <div *dxTemplate="let section of 'fileUploadTemplate'">
          <app-file-upload data-testid="vendor-request-file-upload" labelText="" selectButtonText="Browse or drop files here" [existingFileUrls]="isEditable ? (task?.parentUrls ?? []) : []" (onFileUploadEventEmitter)="onFileUpload($event)" (onFileRemoveEventEmitter)="onFileRemove($event)">
          </app-file-upload>
        </div>
      </dx-form>
      <dx-load-panel data-testid="vendor-request-load-panel" container=".cards-wide" [position]="{ of: '.content' }" [visible]="isLoading" [showPane]="true"></dx-load-panel>
    </form>


  </dx-scroll-view>
</div>